import Core from './core';

export default class ProductStatus extends Core {
  copy() {
    const status = { ...this };
    delete status.logs;
    return status;
  }
}
